import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Legacy route: gallery upload was removed. Redirect to camera capture only.
 */
const HairUploadModePage = () => {
  const location = useLocation();
  return <Navigate to="/hair/capture" replace state={location.state} />;
};

export default HairUploadModePage;
